export default "__VITE_ASSET__Bk4N39Xc__"